import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCareReceiverMutationVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
  careReceiverData: Types.CareReceiverMemberInput;
}>;


export type CreateCareReceiverMutation = { __typename?: 'Mutation', createCareReceiverMember: { __typename?: 'OrganisationMemberUser', id: string, role: Types.OrganisationRole, user: { __typename?: 'User', id: string, uuid: string, firstName?: string | null, lastName?: string | null, username: string } } };


export const CreateCareReceiverDocument = gql`
    mutation CreateCareReceiver($organisationUuid: String!, $careReceiverData: CareReceiverMemberInput!) {
  createCareReceiverMember(
    organisationUuid: $organisationUuid
    data: $careReceiverData
  ) {
    id
    role
    user {
      id
      uuid
      firstName
      lastName
      username
    }
  }
}
    `;
export type CreateCareReceiverMutationFn = Apollo.MutationFunction<CreateCareReceiverMutation, CreateCareReceiverMutationVariables>;

/**
 * __useCreateCareReceiverMutation__
 *
 * To run a mutation, you first call `useCreateCareReceiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareReceiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareReceiverMutation, { data, loading, error }] = useCreateCareReceiverMutation({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *      careReceiverData: // value for 'careReceiverData'
 *   },
 * });
 */
export function useCreateCareReceiverMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareReceiverMutation, CreateCareReceiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareReceiverMutation, CreateCareReceiverMutationVariables>(CreateCareReceiverDocument, options);
      }
export type CreateCareReceiverMutationHookResult = ReturnType<typeof useCreateCareReceiverMutation>;
export type CreateCareReceiverMutationResult = Apollo.MutationResult<CreateCareReceiverMutation>;
export type CreateCareReceiverMutationOptions = Apollo.BaseMutationOptions<CreateCareReceiverMutation, CreateCareReceiverMutationVariables>;